module.exports = __webpack_public_path__ + "img/bottom.c928ac68.png";